// extracted by mini-css-extract-plugin
export default {"newsLink":"NewsListItem_newsLink__19YS8","newsTitle":"NewsListItem_newsTitle__b9URK"};